// @ts-nocheck

import * as React from 'react';


export default <
    InputProps extends Record<any, any>,
    MappedProps extends Record<any, any>,
  >(
    mapper: (arg1: InputProps) => MappedProps,
  ) =>
  (WrappedComponent: React.ComponentType<MappedProps>) =>
  (props: InputProps) =>
    <WrappedComponent {...mapper(props)} />;
